import React from 'react';

import { IServiceLinks } from '@belong/types';

import { TileHeader } from '../../molecules/TileHeader/TileHeader';
import { LinkList } from '../../lists';
import { CardV2 } from '../../contentBlocks';
import { Stack } from '../../ui';

export const ServiceLinks = ({ linkList, header, withCard, ...otherProps }: IServiceLinks) => {
  const List = () => (
    <Stack space={{ xs: 'none', md: 'medium' }} {...otherProps}>
      {header ? <TileHeader {...header} /> : null}
      <LinkList {...linkList} groupName={header?.title} />
    </Stack>
  );
  List.displayName = 'List';

  return withCard ? (
    <CardV2 shadowVariant="AMBIENT_LIGHT">
      <List />
    </CardV2>
  ) : (
    <List />
  );
};

ServiceLinks.displayName = 'ServiceLinks';
